import { api } from "./api";
import { saveAs } from "file-saver";

export const studentsList = async (params: unknown): Promise<any> => {
  const { data } = await api.get("student", { params });
  return data;
};

export const studentsIndicators = async (params: {
  startDate: Date;
  endDate: Date;
}): Promise<any> => {
  const { data } = await api.get("student/indicators", { params });
  return data;
};

export const studentsListById = async (id: number | string): Promise<any> => {
  const { data } = await api.get("student/" + id);
  return data;
};

export const studentCadaster = async (body: any): Promise<any> => {
  const { data } = await api.post("student/cadaster", body);
  return data;
};

export const studentUpdate = async (body: any): Promise<any> => {
  const { data } = await api.put("student/update", body);
  return data;
};

export const studentDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("student/delete", body);
  return data;
};

export const studentDisable = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("student/disable", body);
  return data;
};

export const studentEnable = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("student/enable", body);
  return data;
};

export const approvedFrequency = async (params: unknown): Promise<any> => {
  const { data } = await api.get("/student/approved/frequency", { params });
  return data;
};

export const deleteStudentPlan = async (id: number): Promise<any> => {
  const { data } = await api.delete("/student/plan/" + id);
  return data;
};

export const getGraduationsStudent = async (params: {
  studentId?: number;
}): Promise<any> => {
  const { data } = await api.get("/student/graduation/list", { params });
  return data;
};

export const putGraduationsStudent = async (body: unknown): Promise<any> => {
  const { data } = await api.put("/student/graduation/update", body);
  return data;
};

export const removeGraduationsStudent = async (body: unknown): Promise<any> => {
  const { data } = await api.put("/student/graduation/delete", body);
  return data;
};

export const notificationGraduationsStudent = async (
  body: unknown
): Promise<any> => {
  const { data } = await api.post("/student/graduation/notification", body);
  return data;
};

export const studentPlanSelect = async (body: any): Promise<any> => {
  const { data } = await api.put("student/select-plan-for-student", body);
  return data;
};

export const studentPaymentNotification = async (body: any): Promise<any> => {
  const { data } = await api.post("/student/finance/notification", body);

  return data;
};

export const studentDueDate = async (body: unknown): Promise<unknown> => {
  const { data } = await api.put("/student/update-due-date/", body);
  return data;
};

export const studentConfirmPayment = async (body: any): Promise<unknown> => {
  const { data } = await api.post("/student/confirm-payment", body);
  return data;
};

export const downloadListStudentToCSV = async () => {
  const { data } = await api.get("/student/download-list-student-to-csv", {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "students.csv";
  a.click();
  URL.revokeObjectURL(url);

  return data;
};

export const downloadListStudentPDF = async () => {
  const { data } = await api.get("/student/download-list-student-to-pdf", {
    responseType: "blob",
  });

  const pdfBlob = new Blob([data], { type: "application/pdf" });
  saveAs(pdfBlob, "students.pdf");

  return data;
};

export const studentParent = async (params: any): Promise<[]> => {
  const { data } = await api.get("/student/parent/list", { params });
  return data;
};

// export const dependentsData = async (): Promise<any> => {
//   const { data } = await api.get('/student/parent/data');
//   return data;
// };

export const studentParentCreate = async (body: any): Promise<any> => {
  const { data } = await api.post("/student/store/parent/create", body);
  return data;
};

export const resendStudentRegisterLink = async (id: any): Promise<any> => {
  const { data } = await api.post("/student/resend/" + id);
  return data;
};

export const studentPlanPaymentHistory = async (): Promise<unknown> => {
  const { data } = await api.get("/student/plan/payments-history");
  return data;
};
